<div *ngIf="overlayvisible"
    style="position:absolute; z-index: 100;height:100vh;width:100vw;background-color:black;opacity:0.3"></div>